import { User } from './User';

export class StringList extends User {
  list: string[];
}